import React from 'react';
import TabCardContainer from '../../Componant/Bonus-Ui/Cards/TabCard';

const TabCard = () => {
  return (
    <div className='page-body'>
      <TabCardContainer />
    </div>
  );
};

export default TabCard;
